const ComponentBase = require('../../base/ComponentBase');
/**
 * @constructor
 * @classdesc 截屏
 * @augments G.base.ComponentBase
 * @alias G.common.MousePosition
 * @param {Object} options 构造参数；
 * @param {G.Map} options.map 地图对象
 * @param {String} options.targetId 元素id,
 * @param {String} options.eventName 事件名称,
 * @param {String} [options.format] 展示格式,默认为'{x} | {y}'
 * @param {String} [options.formatType] 坐标前后缀展示格式；example(x坐标为例):1：E 117.1，2：117.1 E
 * @param {Integer} [options.precision] 保留小数位,默认为6
 * @param {String} [options.lnglatFormat] 坐标格式，默认为"DD"；"DD":经纬度坐标小数值,"DMS"：经纬度坐标度分秒,"MM":原始坐标值
 */
let component = ComponentBase.extend({
    options: {},
    initialize(options) {
        ComponentBase.prototype.initialize.call(this, options);
        this.options.format = this.options.format ? this.options.format : '{x} | {y}';
        this.options.precision = this.options.precision ? this.options.precision : 6;
        this.options.lnglatFormat = this.options.lnglatFormat ? this.options.lnglatFormat : "DD";
        this.dom = document.getElementById(this.options.targetId);
        this.srid = this.map.spatialReference;
    },
    /**
     * @inheritDoc
     */
    load() {
        ComponentBase.prototype.load.call(this);
        this.map.listen('mousemove', this._mapListener, this);
    },
    /**
     * @inheritDoc
     */
    unload: function () {
        this.map.off('mousemove', this._mapListener, this);
        ComponentBase.prototype.unload.call(this);
    },
    /**
     * @inheritDoc
     */
    destroy() {
        this.unload();
        ComponentBase.prototype.destroy.call(this);
    },
    /**
     * 添加鼠标在地图上的移动监听
     * @private
     */
    _mapListener: function (event) {
        let data = this._updateView(event.screenX, event.screenY, event.mapX, event.mapY);
        this.fire(this.options.eventName, data);
    },
    /**
     * 更新坐标显示值
     * @param screenX 屏幕像素x
     * @param screenY 屏幕像素y
     * @param mapX  地图坐标X
     * @param mapY 地图坐标Y
     * @private
     */
    _updateView: function (screenX, screenY, mapX, mapY) {
        var dx = parseFloat(mapX);
        var dy = parseFloat(mapY);

        var x = 0;
        var y = 0;
        let returndata = {}
        var self = this;
        var coordFormat = {
            "DD": function (options) {
                var _coord = self._transform([dx,dy], self.srid, 4326);
                dx=_coord[0];
                dy=_coord[1];
                x = dx.toFixed(options.precision);
                y = dy.toFixed(options.precision);
                returndata.x = parseFloat(x);
                returndata.y = parseFloat(y);
            },
            "DMS": function (options) {
                var _coord = self._transform([dx,dy], self.srid, 4326);
                dx=_coord[0];
                dy=_coord[1];
                x = dx.toFixed(options.precision);
                y = dy.toFixed(options.precision);
                returndata.x = dx;
                returndata.y = dy;
                var numX = parseInt(dx);
                var numXF = (dx - numX) * 60;
                var numSX = parseInt(numXF).toString();
                var numMX = parseInt((numXF - numSX) * 60).toString();
                x = numX + '°' + (numSX.length > 1 ? numSX : 0 + numSX) + '′' + (numMX.length > 1 ? numMX : 0 + numMX) + '″';

                var numY = parseInt(dy);
                var numYF = (dy - numY) * 60;
                var numSY = parseInt(numYF).toString();
                var numMY = parseInt((numYF - numSY) * 60).toString();
                y = numY + '°' + (numSY.length > 1 ? numSY : 0 + numSY) + '′' + (numMY.length > 1 ? numMY : 0 + numMY) + '″';
            },
            "MM": function (options) {
                x = dx.toFixed(options.precision);
                y = dy.toFixed(options.precision);
                returndata.x = parseFloat(x);
                returndata.y = parseFloat(y);
            }
        };
        coordFormat[this.options.lnglatFormat](this.options);
        returndata.xText = x;
        returndata.yText = y;
        if (this.options.formatType == "1") {
            if (dx > 0 & dx < 180 & dy > 0 & dy <= 90) {
                x = 'E ' + x;
                y = 'N ' + y;
            }
            else if (dx > 0 & dx < 180 & dy >= -90 & dy < 0) {
                x = 'E ' + x;
                y = 'S ' + y.replace(/-/g, '');
            }
            else if (dx > -180 & dx < 0 & dy > -90 & dy < 0) {
                x = 'W ' + x.replace(/-/g, '');
                y = 'S ' + y.replace(/-/g, '');
            }
            else if (dx > -180 & dx < 0 & dy > 0 & dy <= 90) {
                x = 'W ' + x.replace(/-/g, '');
                y = 'N ' + y;
            }
        } else if (this.options.formatType == "2") {
            if (dx > 0 & dx < 180 & dy > 0 & dy <= 90) {
                x = x +' E';
                y = y + ' N';
            }
            else if (dx > 0 & dx < 180 & dy >= -90 & dy < 0) {
                x = x +' E';
                y = y.replace(/-/g, '') + ' S';
            }
            else if (dx > -180 & dx < 0 & dy > -90 & dy < 0) {
                x = x.replace(/-/g, '') + ' W';
                y = y.replace(/-/g, '') + ' S';
            }
            else if (dx > -180 & dx < 0 & dy > 0 & dy <= 90) {
                x = x.replace(/-/g, '') + ' W';
                y = y + ' N';
            }
        }
        var text = this.options.format;
        text = text.replace("{x}", x);
        text = text.replace("{y}", y);
        returndata.text = text;
        // this.dom.innerHTML=text;
        return returndata;
    },

    _transform(coords, srcSrid, targetSrid) {
        let _transformer = new g2.sfs.CoordinateTransform();
        let _point = new g2.sfs.Point({
            x: coords[0],
            y: coords[1]
        })
        _point.setSpatialReference(srcSrid);
        let _pointTransformed = _transformer.transform(_point, targetSrid);
        let coordsTransformed = [_pointTransformed.x, _pointTransformed.y];
        return coordsTransformed;
    },
});
module.exports = component;